module.exports = __webpack_public_path__ + "img/Picture6.778e9de6.png";